import { forwardRef } from 'react';
import { Dialog } from 'primereact/dialog';
import useReducedMotion from './useReducedMotion';
import './overlayMotion.css';

const AnimatedDialog = forwardRef(function AnimatedDialog({ className = '', transitionOptions, onExited, ...props }, ref) {
    const reduced = useReducedMotion();
    return <Dialog ref={ref} {...props} className={`akello-overlay-dialog ${className}`} transitionOptions={{
        ...transitionOptions,
        timeout: reduced ? 0 : { enter: 220, exit: 180 },
        onExited: (...args) => { transitionOptions?.onExited?.(...args); onExited?.(...args); },
    }} />;
});

export default AnimatedDialog;
